function normalizarFiltro(texto) {
  return (texto || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
}

function coincideNombre(nombre, valores) {
  const slug = normalizarFiltro(nombre)
  return (valores || []).some(valor => {
    if (valor === nombre) return true
    return slug !== "" && normalizarFiltro(valor) === slug
  })
}

function nombresDesdeSlug(valores, catalogo) {
  return (valores || []).map(valor => {
    const encontrado = (catalogo || []).find(item =>
      coincideNombre(item.Nombre, [valor])
    )
    return encontrado ? encontrado.Nombre : valor
  })
}

module.exports = { normalizarFiltro, coincideNombre, nombresDesdeSlug }
